<template>
    <div>       
        <div class="w-full flex flex-col">
            <div class="modal-header flex items-center justify-between cursor-move">
                <h1 class="flex-1 text-2xl">New Project</h1>
                <div @click="hideNewProjectModal">
                    <inline-svg name="close" classes="w-5 h-5 text-white fill-current cursor-pointer"></inline-svg>
                </div>
            </div>
            <div class="bg-white p-4">
                <form class="p-6 border bg-gray-50">
                    <div class="px-2 py-3 flex flex-wrap gap-y-8 gap-x-8">
                        <div class="flex flex-col">
                            <label class="text-sm font-semibold" for="name">Name</label>
                            <input class="form-input" type="text" name="name" v-model="project.name" size="25" required />
                            <div v-if="errors.name" class="form-error">{{ errors.name[0] }}</div>
                        </div>
                        <div class="flex flex-col">
                            <label class="text-sm font-semibold" for="project_type">Project Type</label>
                            <select class="mt-0 max-w-fit max-h-fit form-select h-full" name="project_type" v-model="project.project_type" required>
                                <option value=""></option>
                                <option value="Consolidation">Consolidation</option>
                                <option value="Expansion">Expansion</option>
                                <option value="New Location">New Location</option>
                                <option value="Renewal">Renewal</option>
                            </select>
                            <div v-if="errors.project_type" class="form-error">{{ errors.project_type[0] }}</div>
                        </div>
                        <div class="flex flex-col">
                            <label class="text-sm font-semibold" for="priority">Priority</label>
                            <select class="mt-0 max-w-fit form-select h-full" name="priority" v-model="project.priority" required>
                                <option value=""></option>
                                <option value="Low">Low</option>
                                <option value="Medium">Medium</option>
                                <option value="High">High</option>
                                <option value="Urgent">Urgent</option>
                            </select>
                            <div v-if="errors.priority" class="form-error">{{ errors.priority[0] }}</div>
                        </div>
                        <div class="flex flex-col">
                            <label class="text-sm font-semibold" for="start_date">Start Date</label>
                            <input type="date" class="form-input" name="start_date" size="20" v-model="project.start_date">
                            <div v-if="errors.start_date" class="form-error">{{ errors.start_date[0] }}</div>
                        </div>
                        <div class="flex flex-col">
                            <label class="text-sm font-semibold" for="end_date">End Date</label>
                            <input type="date" class="form-input" name="end_date" size="20" v-model="project.end_date">
                            <div v-if="errors.end_date" class="form-error">{{ errors.end_date[0] }}</div>
                        </div>
                        <div class="flex flex-col">
                            <label class="text-sm font-semibold" for="property_type">Property Type</label>
                            <select class="mt-0 max-w-fit form-select h-full" name="property_type" v-model="project.property_type" required>
                                <option value=""></option>
                                <option value="Office">Office</option>
                                <option value="Industrial">Industrial</option>
                                <option value="Flex">Flex</option>
                                <option value="Land">Land</option>
                                <option value="Retail">Retail</option>
                            </select>
                            <div v-if="errors.property_type" class="form-error">{{ errors.property_type[0] }}</div>
                        </div>
                        <div class="flex flex-col">
                            <label class="text-sm font-semibold" for="property_usage">Property Usage</label>
                            <select class="mt-0 max-w-fit form-select h-full" name="property_usage" v-model="project.property_usage" required>
                                <option value=""></option>
                                <option value="Corporate HQ">Corporate HQ</option>
                                <option value="Operations">Operations</option>
                                <option value="Production">Production</option>
                                <option value="Sublet">Sublet</option>
                                <option value="Vacant">Vacant</option>
                            </select>
                            <div v-if="errors.property_usage" class="form-error">{{ errors.property_usage[0] }}</div>
                        </div>
                        <div class="flex flex-col">
                            <label class="text-sm font-semibold" for="property_region">Property Region</label>
                            <select class="mt-0 max-w-fit form-select h-full" name="property_region" v-model="project.property_region" required>
                                <option value=""></option>
                                <option value="Central">Central</option>
                                <option value="Mid-Atlantic">Mid-Atlantic</option>
                                <option value="Northeast">Northeast</option>
                                <option value="Northwest">Northwest</option>
                                <option value="Outside USA">Outside USA</option>
                                <option value="Southeast">Southeast</option>
                                <option value="Southwest">Southwest</option>
                            </select>
                            <div v-if="errors.property_region" class="form-error">{{ errors.property_region[0] }}</div>
                        </div>
                        <div class="flex flex-col">
                            <label class="text-sm font-semibold" for="required_sq_ft">Required Sq. Ft.</label>
                            <number-input name="required_sq_ft" v-model="project.required_sq_ft" classes="text-sm text-right"></number-input>
                            <div v-if="errors.required_sq_ft" class="form-error">{{ errors.required_sq_ft[0] }}</div>
                        </div>
                    </div>
                    <div class="px-2 mt-6 w-full flex flex-col">
                        <label class="text-sm font-semibold" for="description">Description</label>
                        <textarea class="w-full form-textarea" name="description" rows="6" v-model="project.description" :v-text="project.description"></textarea>
                        <div v-if="errors.description" class="form-error">{{ errors.description[0] }}</div>
                    </div>
                </form>
            </div>
            <div class="p-4 flex items-center justify-end bg-gray-100">
                <button class="btn btn-secondary mr-2" @click.prevent="hideNewProjectModal">Close</button>
                <button class="btn btn-green" @click.prevent="createProject">
                    <span v-if="loading">
                        <inline-svg name="loading-button"></inline-svg>                                
                    </span>
                    <span v-if="! loading">Create Project</span>
                </button>
            </div>
        </div>

        <notifications classes="notification" position="bottom right"></notifications>
    </div>
</template>

<script>

    export default {
        props: {

        },

        data() {
            return {
                project: {},
                errors: '',
                loading: false           
            }
        },

        computed: {

        },

        methods: {
            hideNewProjectModal() {
                this.$modal.hide('new-project');
            },

            createProject() {
                this.loading = true;

                axios.post('/projects', this.project)
                    .then((response) => {
                        this.$modal.hide('new-project');

                        this.$notify({
                            type: 'success',
                            title: 'Project Created',
                            text: 'Redirecting to Project...'
                        });

                        setTimeout(() => {
                            window.location = response.data.project.view_url;
                        }, 2000);
                    })
                    .catch((error) => {
                        console.log(error);
                        this.errors = error.response.data.errors;
                    }).finally(() => {
                        this.loading = false;
                    });
            }
        }
    }
</script>